import { Panel } from '../../..'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import history from '../../../../history'
import { GemGridOverlayPanel } from './GemGridOverlayPanel'
import { getCurrentPath } from '../../../../helpers/browser'
import QuestionSingle from '../../../homeowners/Questions/Single'
import { useTrackingContext } from '../../../../providers/tracking'
import { TrackingEventConstants } from '../../../../constants/tracking'

import styles from './GemGrid.module.scss'

const propTypes = {
  className: PropTypes.string,
  horizontal: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      amount: PropTypes.number,
      title: PropTypes.node,
      icon: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
      content: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
    })
  ),
  question: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  topic: PropTypes.string,
  topicKey: PropTypes.string,
  collapsed: PropTypes.bool,
  disableCospo: PropTypes.bool,
  overlayPanelName: PropTypes.string,
  overlayPanelFrom: PropTypes.string,
  overlayPanelTitle: PropTypes.string
}

const defaultProps = {
  disableCospo: false
}

const GemGrid = ({
  className,
  horizontal,
  data,
  disableCospo,
  collapsed,
  question,
  topic,
  topicKey,
  overlayPanelName,
  overlayPanelFrom,
  overlayPanelTitle
}) => {
  const { trackingClient } = useTrackingContext()

  return (
    <div className={classnames(styles.container, collapsed && styles.collapsed, horizontal && styles.horizontal)}>
      <GemGridOverlayPanel
        data={data}
        from={overlayPanelFrom}
        name={overlayPanelName}
        title={overlayPanelTitle}
        disableCospo={disableCospo}
      />
      <div className={classnames(className, styles.gemGrid)}>
        {data.map(Gem => (
          <Gem.Gem
            horizontal={horizontal}
            key={Gem.key}
            onClick={() => {
              if (overlayPanelName && overlayPanelFrom) {
                TrackingEventConstants[Gem.key] &&
                  trackingClient?.cashoutOptionExplored({
                    cash_out_type: TrackingEventConstants[Gem.key]
                  })
                history.push(`${getCurrentPath()}/${overlayPanelName}/${Gem.key.toLowerCase()}`)
              }
            }}
          />
        ))}
      </div>
      {question && topic && (
        <Panel.Footer>
          <QuestionSingle disableCospo={disableCospo} question={question} topic={topic} topicKey={topicKey} />
        </Panel.Footer>
      )}
    </div>
  )
}

GemGrid.propTypes = propTypes
GemGrid.defaultProps = defaultProps
export default GemGrid
